export const TESTIDS = {
    nav: {
        root: "nav-root",
        logo: "nav-logo",
        tabHome: "nav-tab-home",
        tabUC: "nav-tab-usecases",
        tabProducts: "nav-tab-products",
        tabPractices: "nav-tab-practices",
        tabIndustries: "nav-tab-industries",
        tabTech: "nav-tab-technology",
        tabAbout: "nav-tab-about",
        bookCall: "nav-book-call",
        phone: "nav-phone",
        email: "nav-email",
        megaPanel: "mega-panel",
        megaIndustry: (i) => `mega-industry-${i}`,
        megaCard: (id) => `mega-uc-${id}`,
        megaSeeAll: "mega-see-all",
    },
    hero: {
        root: "hero-root",
        video: "hero-video",
        mute: "hero-mute",
        bookCall: "hero-book-call",
        what: "hero-what",
        tagline: "hero-tagline",
    },
    home: {
        what: "home-what",
        stats: "home-stats",
        statItem: (i) => `home-stat-${i}`,
        ctaBand: "home-cta-band",
        ctaBandBtn: "home-cta-band-btn",
    },
    uclist: {
        root: "uc-list-root",
        indTab: (i) => `uc-ind-tab-${i}`,
        funcTab: (id) => `uc-func-tab-${id}`,
        grid: "uc-grid",
        card: (id) => `uc-card-${id}`,
    },
    ucDetail: {
        root: "uc-detail-root",
        problem: "uc-problem",
        solution: "uc-solution",
        outcome: "uc-outcome",
        bookCall: "uc-book-call",
    },
    tech: {
        root: "tech-root",
        thero: "tech-thero",
        diagram: "tech-diagram",
        cfg: "tech-configurator",
        cfgVoice: (v) => `cfg-voice-${v}`,
        cfgLang: (v) => `cfg-lang-${v}`,
        cfgKnow: (v) => `cfg-know-${v}`,
        cfgChan: (v) => `cfg-chan-${v}`,
        cfgGoLive: "cfg-go-live",
        chips: "tech-chips",
    },
    about: {
        root: "about-root",
        bookCall: "about-book-call",
        bookCallCta: "about-book-call-cta",
    },
    practices: {
        root: "practices-root",
        card: (id) => `practice-card-${id}`,
    },
    products: {
        root: "products-root",
        card: (id) => `product-card-${id}`,
    },
    industries: {
        root: "industries-root",
        card: (id) => `industry-card-${id}`,
    },
    book: {
        modal: "book-modal",
        open: "book-open",
        close: "book-close",
        name: "book-name",
        company: "book-company",
        email: "book-email",
        phone: "book-phone",
        requirement: "book-requirement",
        submit: "book-submit",
        success: "book-success",
        talkNow: "book-talk-now",
    },
    chat: {
        bubble: "chat-bubble",
        panel: "chat-panel",
        close: "chat-close",
        qr: (id) => `chat-qr-${id}`,
        toHuman: "chat-to-human",
    },
    footer: {
        root: "footer-root",
        bookCall: "footer-book-call",
    },
    agentFloat: "agent-float-btn",
};

export const HOME = { emergentLink: "home-emergent-link" };
